import React from 'react';
import { Config, isMobileDevice } from '@deporvillage/utils-library-component';
import { HeaderMobile, HeaderDesktop } from '@deporvillage/header-component';
import { FooterMobile, FooterDesktop } from '@deporvillage/footer-component';

const MobileThresholdWidth = 1035;

const Header = ({ model }) => {
    const { width } = React.useContext(Config);
    const [isMobileLayout, setIsMobileLayout] = React.useState(true);

    React.useEffect(() => {
        setIsMobileLayout(isMobileDevice() || width < MobileThresholdWidth);
    }, [width]);

    return (
        <div className={`${width ? '' : 'header-component'}`}>
            {
                /* istanbul ignore next */
                !width || isMobileLayout ? model && <HeaderMobile model={model} /> : null
            }
            {
                /* istanbul ignore next */ 
                !width || !isMobileLayout ? model && <HeaderDesktop model={model} /> : null
            }
        </div>
    );
};

const Footer = ({ model }) => {
    const { width } = React.useContext(Config);
    const [isMobileLayout, setIsMobileLayout] = React.useState(true);

    React.useEffect(() => {
        setIsMobileLayout(isMobileDevice() || width < MobileThresholdWidth);
    }, [width]);

    return (
        <div className={`${width ? '' : 'footer-component'}`}>
            {
                /* istanbul ignore next */
                !width || isMobileLayout ? model && <FooterMobile model={model} /> : null
            }
            {
                /* istanbul ignore next */
                !width || !isMobileLayout ? model && <FooterDesktop model={model} /> : null
            }
        </div>
    );
};

export default {
    Header,
    Footer,
};

export {
    Header,
    Footer,
};
